<template>
  <el-scrollbar class="kq-theme-submenu scroll-hide-x" :data="menus">
    <el-menu
      :collapse="collapse"
      :collapse-transition="false"
      unique-opened
      :default-active="$route.path"
      @select="selectMenu"
    >
      <template v-for="item of menus">
        <side-submenu-tree :key="item.path" v-if="item.children && item.children.length > 0" :menu="item" />
        <side-submenu-item :key="item.path" v-else :menu="item" />
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapState } from 'vuex'
import SideSubmenuTree from './SideSubmenuTree'
import SideSubmenuItem from './SideSubmenuItem'

export default {
  name: 'SideSubmenu',
  components: {
    SideSubmenuItem,
    SideSubmenuTree
  },
  props: {
    menus: {
      type: Array,
      required: true
    },
    collapse: {
      type: Boolean,
      required: true
    },
    currentSubmenuPath: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('tab', ['tabs'])
  },
  methods: {
    selectMenu(path) {
      if (this.$util.validate.isExternal(path)) {
        this.$util.open(path)
      } else {
        const info = this.tabs.find(tab => tab.path === path)
        if (info) {
          this.$router.push({
            name: info.name,
            params: info.params || {},
            query: info.query || {}
          })
        } else {
          this.$router.push({ path: path })
        }
      }
    }
  }
}
</script>
